import React from "react"
import { StoreProvider } from "./src/context/store-context"

const wrap = ({ element }) => {
  return <StoreProvider>{element}</StoreProvider>
}
export default wrap